<template>
  <div class="order-step">
    <next-prev-menu
      :disabled="false"
      :previous="true"
      title="Naar Factureren"
      @next-step="$router.push({ name: 'quoteOrderInvoice' })"
      @prev-step="$router.push({ name: 'quoteOrderDescription' })"
    ></next-prev-menu>

    <deliver
      :orderDetails="orderDetails"
      :returnText="false"
      :hideSub="true"
      @updateOrder="updateOrder"
    >
    </deliver>
  </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useQuoteOrderStore } from '@/features/quoteOrder/QuoteOrder.store'
import NextPrevMenu from '@/components/NextPrevMenu.vue'
import OrderMixin from '@/mixins/OrderMixin'
import Deliver from '@/components/Deliver.vue'

export default {
  data() {
    return {}
  },
  mixins: [OrderMixin],
  components: {
    NextPrevMenu,
    Deliver
  },
  methods: {
    updateOrder(val) {
      this.quoteOrderStore.updateOrderDetails(val[0], val[1])
    }
  },
  computed: {
    ...mapStores(useQuoteOrderStore),
    orderDetails() {
      return this.quoteOrderStore.orderDetails
    }
  }
}
</script>
